<cer-form *ngIf="setupComplete" #form [panes]="panes">
  <ng-template #mainTemplate>
    <cer-grid #grid id="grid" [dataParent]="true"></cer-grid>
  </ng-template>
  <ng-template #rightTemplate>
    <cer-app-file-viewer-tab #tabAttachments [token]="attachmentToken" 
      [refTableId]="1" [refRowId]="attachmentRefRowId"
      [attachments]="attachments"
      [tabSelectedIndexInitial]="attachmentIdxDefault"
      [enableChat]="true" [chats]="chats" 
      [saveUrl]="attachmentSaveUrl"
      [removeUrl]="attachmentRemoveUrl"
      [allowTransfer]="true"
      [tabCheckBoxAllowed]="true"
      (tabSelectedIndexChanged)="onAttachmentTabSelectedIndexChanged($event)"
      (viewCommand)="attachmentService.onFileViewerCommand($event)"
      (tabCheckBoxApply)="onAttachmentCheckBoxApply($event)">
    </cer-app-file-viewer-tab>
  </ng-template>
  <ng-template #bottomTemplate>
    <cer-form-pane pane="bottom">
    </cer-form-pane>
  </ng-template>
</cer-form>